// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2MX_Y","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__27Qi7"};